module.exports = __webpack_public_path__ + "img/16.5cb734a1.jpg";